export default __webpack_public_path__ + "static/media/hero-bg-p.7a852aee.jpg";